import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { fetchTenantBranding } from '../../Redux/ActionCreators/qualifyQuestionsAction'
import './Chat.scss'

const SendIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
  </svg>
)


const AttachIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" />
  </svg>
)

const ReconnectIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 4v6h6" />
    <path d="M23 20v-6h-6" />
    <path d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15" />
  </svg>
)

const UA = typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''
const IS_ANDROID = /Android/i.test(UA)
const IS_IOS = /iPhone|iPad|iPod/i.test(UA)
const IS_IN_APP_BROWSER = /FBAN|FBAV|FB_IAB|Instagram|Line\//i.test(UA)

const openExternally = (url) => {
  if (IS_ANDROID) {
    const withoutScheme = url.replace(/^https?:\/\//, '')
    window.location.href = `intent://${withoutScheme}#Intent;scheme=https;package=com.android.chrome;end;`
    return
  }
  if (IS_IOS) {
    window.location.href = url.replace(/^https/, 'x-safari-https')
    return
  }
  window.open(url, '_blank', 'noopener,noreferrer')
}

const COUNTRY_CODES = [
  { code: "AF", dialCode: "+93",   name: "Afghanistan" },
  { code: "AL", dialCode: "+355",  name: "Albania" },
  { code: "DZ", dialCode: "+213",  name: "Algeria" },
  { code: "AD", dialCode: "+376",  name: "Andorra" },
  { code: "AO", dialCode: "+244",  name: "Angola" },
  { code: "AG", dialCode: "+1268", name: "Antigua and Barbuda" },
  { code: "AR", dialCode: "+54",   name: "Argentina" },
  { code: "AM", dialCode: "+374",  name: "Armenia" },
  { code: "AU", dialCode: "+61",   name: "Australia" },
  { code: "AT", dialCode: "+43",   name: "Austria" },
  { code: "AZ", dialCode: "+994",  name: "Azerbaijan" },
  { code: "BS", dialCode: "+1242", name: "Bahamas" },
  { code: "BH", dialCode: "+973",  name: "Bahrain" },
  { code: "BD", dialCode: "+880",  name: "Bangladesh" },
  { code: "BB", dialCode: "+1246", name: "Barbados" },
  { code: "BY", dialCode: "+375",  name: "Belarus" },
  { code: "BE", dialCode: "+32",   name: "Belgium" },
  { code: "BZ", dialCode: "+501",  name: "Belize" },
  { code: "BJ", dialCode: "+229",  name: "Benin" },
  { code: "BT", dialCode: "+975",  name: "Bhutan" },
  { code: "BO", dialCode: "+591",  name: "Bolivia" },
  { code: "BA", dialCode: "+387",  name: "Bosnia and Herzegovina" },
  { code: "BW", dialCode: "+267",  name: "Botswana" },
  { code: "BR", dialCode: "+55",   name: "Brazil" },
  { code: "BN", dialCode: "+673",  name: "Brunei" },
  { code: "BG", dialCode: "+359",  name: "Bulgaria" },
  { code: "BF", dialCode: "+226",  name: "Burkina Faso" },
  { code: "BI", dialCode: "+257",  name: "Burundi" },
  { code: "CV", dialCode: "+238",  name: "Cabo Verde" },
  { code: "KH", dialCode: "+855",  name: "Cambodia" },
  { code: "CM", dialCode: "+237",  name: "Cameroon" },
  { code: "CA", dialCode: "+1",    name: "Canada" },
  { code: "CF", dialCode: "+236",  name: "Central African Republic" },
  { code: "TD", dialCode: "+235",  name: "Chad" },
  { code: "CL", dialCode: "+56",   name: "Chile" },
  { code: "CN", dialCode: "+86",   name: "China" },
  { code: "CO", dialCode: "+57",   name: "Colombia" },
  { code: "KM", dialCode: "+269",  name: "Comoros" },
  { code: "CG", dialCode: "+242",  name: "Congo" },
  { code: "CR", dialCode: "+506",  name: "Costa Rica" },
  { code: "HR", dialCode: "+385",  name: "Croatia" },
  { code: "CU", dialCode: "+53",   name: "Cuba" },
  { code: "CY", dialCode: "+357",  name: "Cyprus" },
  { code: "CZ", dialCode: "+420",  name: "Czech Republic" },
  { code: "DK", dialCode: "+45",   name: "Denmark" },
  { code: "DJ", dialCode: "+253",  name: "Djibouti" },
  { code: "DM", dialCode: "+1767", name: "Dominica" },
  { code: "DO", dialCode: "+1809", name: "Dominican Republic" },
  { code: "EC", dialCode: "+593",  name: "Ecuador" },
  { code: "EG", dialCode: "+20",   name: "Egypt" },
  { code: "SV", dialCode: "+503",  name: "El Salvador" },
  { code: "GQ", dialCode: "+240",  name: "Equatorial Guinea" },
  { code: "ER", dialCode: "+291",  name: "Eritrea" },
  { code: "EE", dialCode: "+372",  name: "Estonia" },
  { code: "SZ", dialCode: "+268",  name: "Eswatini" },
  { code: "ET", dialCode: "+251",  name: "Ethiopia" },
  { code: "FJ", dialCode: "+679",  name: "Fiji" },
  { code: "FI", dialCode: "+358",  name: "Finland" },
  { code: "FR", dialCode: "+33",   name: "France" },
  { code: "GA", dialCode: "+241",  name: "Gabon" },
  { code: "GM", dialCode: "+220",  name: "Gambia" },
  { code: "GE", dialCode: "+995",  name: "Georgia" },
  { code: "DE", dialCode: "+49",   name: "Germany" },
  { code: "GH", dialCode: "+233",  name: "Ghana" },
  { code: "GR", dialCode: "+30",   name: "Greece" },
  { code: "GD", dialCode: "+1473", name: "Grenada" },
  { code: "GT", dialCode: "+502",  name: "Guatemala" },
  { code: "GN", dialCode: "+224",  name: "Guinea" },
  { code: "GW", dialCode: "+245",  name: "Guinea-Bissau" },
  { code: "GY", dialCode: "+592",  name: "Guyana" },
  { code: "HT", dialCode: "+509",  name: "Haiti" },
  { code: "HN", dialCode: "+504",  name: "Honduras" },
  { code: "HU", dialCode: "+36",   name: "Hungary" },
  { code: "IS", dialCode: "+354",  name: "Iceland" },
  { code: "IN", dialCode: "+91",   name: "India" },
  { code: "ID", dialCode: "+62",   name: "Indonesia" },
  { code: "IR", dialCode: "+98",   name: "Iran" },
  { code: "IQ", dialCode: "+964",  name: "Iraq" },
  { code: "IE", dialCode: "+353",  name: "Ireland" },
  { code: "IL", dialCode: "+972",  name: "Israel" },
  { code: "IT", dialCode: "+39",   name: "Italy" },
  { code: "JM", dialCode: "+1876", name: "Jamaica" },
  { code: "JP", dialCode: "+81",   name: "Japan" },
  { code: "JO", dialCode: "+962",  name: "Jordan" },
  { code: "KZ", dialCode: "+7",    name: "Kazakhstan" },
  { code: "KE", dialCode: "+254",  name: "Kenya" },
  { code: "KI", dialCode: "+686",  name: "Kiribati" },
  { code: "KW", dialCode: "+965",  name: "Kuwait" },
  { code: "KG", dialCode: "+996",  name: "Kyrgyzstan" },
  { code: "LA", dialCode: "+856",  name: "Laos" },
  { code: "LV", dialCode: "+371",  name: "Latvia" },
  { code: "LB", dialCode: "+961",  name: "Lebanon" },
  { code: "LS", dialCode: "+266",  name: "Lesotho" },
  { code: "LR", dialCode: "+231",  name: "Liberia" },
  { code: "LY", dialCode: "+218",  name: "Libya" },
  { code: "LI", dialCode: "+423",  name: "Liechtenstein" },
  { code: "LT", dialCode: "+370",  name: "Lithuania" },
  { code: "LU", dialCode: "+352",  name: "Luxembourg" },
  { code: "MG", dialCode: "+261",  name: "Madagascar" },
  { code: "MW", dialCode: "+265",  name: "Malawi" },
  { code: "MY", dialCode: "+60",   name: "Malaysia" },
  { code: "MV", dialCode: "+960",  name: "Maldives" },
  { code: "ML", dialCode: "+223",  name: "Mali" },
  { code: "MT", dialCode: "+356",  name: "Malta" },
  { code: "MH", dialCode: "+692",  name: "Marshall Islands" },
  { code: "MR", dialCode: "+222",  name: "Mauritania" },
  { code: "MU", dialCode: "+230",  name: "Mauritius" },
  { code: "MX", dialCode: "+52",   name: "Mexico" },
  { code: "FM", dialCode: "+691",  name: "Micronesia" },
  { code: "MD", dialCode: "+373",  name: "Moldova" },
  { code: "MC", dialCode: "+377",  name: "Monaco" },
  { code: "MN", dialCode: "+976",  name: "Mongolia" },
  { code: "ME", dialCode: "+382",  name: "Montenegro" },
  { code: "MA", dialCode: "+212",  name: "Morocco" },
  { code: "MZ", dialCode: "+258",  name: "Mozambique" },
  { code: "MM", dialCode: "+95",   name: "Myanmar" },
  { code: "NA", dialCode: "+264",  name: "Namibia" },
  { code: "NR", dialCode: "+674",  name: "Nauru" },
  { code: "NP", dialCode: "+977",  name: "Nepal" },
  { code: "NL", dialCode: "+31",   name: "Netherlands" },
  { code: "NZ", dialCode: "+64",   name: "New Zealand" },
  { code: "NI", dialCode: "+505",  name: "Nicaragua" },
  { code: "NE", dialCode: "+227",  name: "Niger" },
  { code: "NG", dialCode: "+234",  name: "Nigeria" },
  { code: "KP", dialCode: "+850",  name: "North Korea" },
  { code: "MK", dialCode: "+389",  name: "North Macedonia" },
  { code: "NO", dialCode: "+47",   name: "Norway" },
  { code: "OM", dialCode: "+968",  name: "Oman" },
  { code: "PK", dialCode: "+92",   name: "Pakistan" },
  { code: "PW", dialCode: "+680",  name: "Palau" },
  { code: "PA", dialCode: "+507",  name: "Panama" },
  { code: "PG", dialCode: "+675",  name: "Papua New Guinea" },
  { code: "PY", dialCode: "+595",  name: "Paraguay" },
  { code: "PE", dialCode: "+51",   name: "Peru" },
  { code: "PH", dialCode: "+63",   name: "Philippines" },
  { code: "PL", dialCode: "+48",   name: "Poland" },
  { code: "PT", dialCode: "+351",  name: "Portugal" },
  { code: "QA", dialCode: "+974",  name: "Qatar" },
  { code: "RO", dialCode: "+40",   name: "Romania" },
  { code: "RU", dialCode: "+7",    name: "Russia" },
  { code: "RW", dialCode: "+250",  name: "Rwanda" },
  { code: "KN", dialCode: "+1869", name: "Saint Kitts and Nevis" },
  { code: "LC", dialCode: "+1758", name: "Saint Lucia" },
  { code: "VC", dialCode: "+1784", name: "Saint Vincent and the Grenadines" },
  { code: "WS", dialCode: "+685",  name: "Samoa" },
  { code: "SM", dialCode: "+378",  name: "San Marino" },
  { code: "ST", dialCode: "+239",  name: "Sao Tome and Principe" },
  { code: "SA", dialCode: "+966",  name: "Saudi Arabia" },
  { code: "SN", dialCode: "+221",  name: "Senegal" },
  { code: "RS", dialCode: "+381",  name: "Serbia" },
  { code: "SC", dialCode: "+248",  name: "Seychelles" },
  { code: "SL", dialCode: "+232",  name: "Sierra Leone" },
  { code: "SG", dialCode: "+65",   name: "Singapore" },
  { code: "SK", dialCode: "+421",  name: "Slovakia" },
  { code: "SI", dialCode: "+386",  name: "Slovenia" },
  { code: "SB", dialCode: "+677",  name: "Solomon Islands" },
  { code: "SO", dialCode: "+252",  name: "Somalia" },
  { code: "ZA", dialCode: "+27",   name: "South Africa" },
  { code: "KR", dialCode: "+82",   name: "South Korea" },
  { code: "SS", dialCode: "+211",  name: "South Sudan" },
  { code: "ES", dialCode: "+34",   name: "Spain" },
  { code: "LK", dialCode: "+94",   name: "Sri Lanka" },
  { code: "SD", dialCode: "+249",  name: "Sudan" },
  { code: "SR", dialCode: "+597",  name: "Suriname" },
  { code: "SE", dialCode: "+46",   name: "Sweden" },
  { code: "CH", dialCode: "+41",   name: "Switzerland" },
  { code: "SY", dialCode: "+963",  name: "Syria" },
  { code: "TW", dialCode: "+886",  name: "Taiwan" },
  { code: "TJ", dialCode: "+992",  name: "Tajikistan" },
  { code: "TZ", dialCode: "+255",  name: "Tanzania" },
  { code: "TH", dialCode: "+66",   name: "Thailand" },
  { code: "TL", dialCode: "+670",  name: "Timor-Leste" },
  { code: "TG", dialCode: "+228",  name: "Togo" },
  { code: "TO", dialCode: "+676",  name: "Tonga" },
  { code: "TT", dialCode: "+1868", name: "Trinidad and Tobago" },
  { code: "TN", dialCode: "+216",  name: "Tunisia" },
  { code: "TR", dialCode: "+90",   name: "Turkey" },
  { code: "TM", dialCode: "+993",  name: "Turkmenistan" },
  { code: "TV", dialCode: "+688",  name: "Tuvalu" },
  { code: "UG", dialCode: "+256",  name: "Uganda" },
  { code: "UA", dialCode: "+380",  name: "Ukraine" },
  { code: "AE", dialCode: "+971",  name: "UAE" },
  { code: "GB", dialCode: "+44",   name: "United Kingdom" },
  { code: "US", dialCode: "+1",    name: "United States" },
  { code: "UY", dialCode: "+598",  name: "Uruguay" },
  { code: "UZ", dialCode: "+998",  name: "Uzbekistan" },
  { code: "VU", dialCode: "+678",  name: "Vanuatu" },
  { code: "VE", dialCode: "+58",   name: "Venezuela" },
  { code: "VN", dialCode: "+84",   name: "Vietnam" },
  { code: "YE", dialCode: "+967",  name: "Yemen" },
  { code: "ZM", dialCode: "+260",  name: "Zambia" },
  { code: "ZW", dialCode: "+263",  name: "Zimbabwe" },
]

// Primary IANA time zone(s) for each country, used only as a fallback when
// the browser locale carries no region subtag -- doesn't need to be
// exhaustive for multi-zone countries, just enough to make a reasonable guess.
const TIMEZONE_COUNTRY_MAP = {
  'Asia/Kabul': 'AF', 'Europe/Tirane': 'AL', 'Africa/Algiers': 'DZ', 'Europe/Andorra': 'AD',
  'Africa/Luanda': 'AO', 'America/Antigua': 'AG', 'America/Argentina/Buenos_Aires': 'AR',
  'Asia/Yerevan': 'AM', 'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Australia/Brisbane': 'AU',
  'Australia/Perth': 'AU', 'Australia/Adelaide': 'AU', 'Australia/Darwin': 'AU', 'Australia/Hobart': 'AU',
  'Europe/Vienna': 'AT', 'Asia/Baku': 'AZ', 'America/Nassau': 'BS', 'Asia/Bahrain': 'BH',
  'Asia/Dhaka': 'BD', 'America/Barbados': 'BB', 'Europe/Minsk': 'BY', 'Europe/Brussels': 'BE',
  'America/Belize': 'BZ', 'Africa/Porto-Novo': 'BJ', 'Asia/Thimphu': 'BT', 'America/La_Paz': 'BO',
  'Europe/Sarajevo': 'BA', 'Africa/Gaborone': 'BW', 'America/Sao_Paulo': 'BR', 'America/Manaus': 'BR',
  'America/Fortaleza': 'BR', 'America/Recife': 'BR', 'America/Bahia': 'BR', 'America/Belem': 'BR',
  'America/Cuiaba': 'BR', 'America/Rio_Branco': 'BR', 'Asia/Brunei': 'BN', 'Europe/Sofia': 'BG',
  'Africa/Ouagadougou': 'BF', 'Africa/Bujumbura': 'BI', 'Atlantic/Cape_Verde': 'CV', 'Asia/Phnom_Penh': 'KH',
  'Africa/Douala': 'CM', 'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'America/Edmonton': 'CA',
  'America/Winnipeg': 'CA', 'America/Halifax': 'CA', 'America/St_Johns': 'CA', 'America/Regina': 'CA',
  'Africa/Bangui': 'CF', 'Africa/Ndjamena': 'TD', 'America/Santiago': 'CL', 'Asia/Shanghai': 'CN',
  'Asia/Urumqi': 'CN', 'America/Bogota': 'CO', 'Indian/Comoro': 'KM', 'Africa/Brazzaville': 'CG',
  'America/Costa_Rica': 'CR', 'Europe/Zagreb': 'HR', 'America/Havana': 'CU', 'Asia/Nicosia': 'CY',
  'Europe/Prague': 'CZ', 'Europe/Copenhagen': 'DK', 'Africa/Djibouti': 'DJ', 'America/Dominica': 'DM',
  'America/Santo_Domingo': 'DO', 'America/Guayaquil': 'EC', 'Africa/Cairo': 'EG', 'America/El_Salvador': 'SV',
  'Africa/Malabo': 'GQ', 'Africa/Asmara': 'ER', 'Europe/Tallinn': 'EE', 'Africa/Mbabane': 'SZ',
  'Africa/Addis_Ababa': 'ET', 'Pacific/Fiji': 'FJ', 'Europe/Helsinki': 'FI', 'Europe/Paris': 'FR',
  'Africa/Libreville': 'GA', 'Africa/Banjul': 'GM', 'Asia/Tbilisi': 'GE', 'Europe/Berlin': 'DE',
  'Africa/Accra': 'GH', 'Europe/Athens': 'GR', 'America/Grenada': 'GD', 'America/Guatemala': 'GT',
  'Africa/Conakry': 'GN', 'Africa/Bissau': 'GW', 'America/Guyana': 'GY', 'America/Port-au-Prince': 'HT',
  'America/Tegucigalpa': 'HN', 'Europe/Budapest': 'HU', 'Atlantic/Reykjavik': 'IS', 'Asia/Kolkata': 'IN',
  'Asia/Jakarta': 'ID', 'Asia/Makassar': 'ID', 'Asia/Jayapura': 'ID', 'Asia/Tehran': 'IR',
  'Asia/Baghdad': 'IQ', 'Europe/Dublin': 'IE', 'Asia/Jerusalem': 'IL', 'Europe/Rome': 'IT',
  'America/Jamaica': 'JM', 'Asia/Tokyo': 'JP', 'Asia/Amman': 'JO', 'Asia/Almaty': 'KZ',
  'Asia/Aqtobe': 'KZ', 'Africa/Nairobi': 'KE', 'Pacific/Tarawa': 'KI', 'Asia/Kuwait': 'KW',
  'Asia/Bishkek': 'KG', 'Asia/Vientiane': 'LA', 'Europe/Riga': 'LV', 'Asia/Beirut': 'LB',
  'Africa/Maseru': 'LS', 'Africa/Monrovia': 'LR', 'Africa/Tripoli': 'LY', 'Europe/Vaduz': 'LI',
  'Europe/Vilnius': 'LT', 'Europe/Luxembourg': 'LU', 'Indian/Antananarivo': 'MG', 'Africa/Blantyre': 'MW',
  'Asia/Kuala_Lumpur': 'MY', 'Asia/Kuching': 'MY', 'Indian/Maldives': 'MV', 'Africa/Bamako': 'ML',
  'Europe/Malta': 'MT', 'Pacific/Majuro': 'MH', 'Africa/Nouakchott': 'MR', 'Indian/Mauritius': 'MU',
  'America/Mexico_City': 'MX', 'America/Tijuana': 'MX', 'America/Cancun': 'MX', 'America/Monterrey': 'MX',
  'Pacific/Chuuk': 'FM', 'Europe/Chisinau': 'MD', 'Europe/Monaco': 'MC', 'Asia/Ulaanbaatar': 'MN',
  'Europe/Podgorica': 'ME', 'Africa/Casablanca': 'MA', 'Africa/Maputo': 'MZ', 'Asia/Yangon': 'MM',
  'Africa/Windhoek': 'NA', 'Pacific/Nauru': 'NR', 'Asia/Kathmandu': 'NP', 'Europe/Amsterdam': 'NL',
  'Pacific/Auckland': 'NZ', 'America/Managua': 'NI', 'Africa/Niamey': 'NE', 'Africa/Lagos': 'NG',
  'Asia/Pyongyang': 'KP', 'Europe/Skopje': 'MK', 'Europe/Oslo': 'NO', 'Asia/Muscat': 'OM',
  'Asia/Karachi': 'PK', 'Pacific/Palau': 'PW', 'America/Panama': 'PA', 'Pacific/Port_Moresby': 'PG',
  'America/Asuncion': 'PY', 'America/Lima': 'PE', 'Asia/Manila': 'PH', 'Europe/Warsaw': 'PL',
  'Europe/Lisbon': 'PT', 'Asia/Qatar': 'QA', 'Europe/Bucharest': 'RO', 'Europe/Moscow': 'RU',
  'Asia/Yekaterinburg': 'RU', 'Asia/Novosibirsk': 'RU', 'Asia/Krasnoyarsk': 'RU', 'Asia/Irkutsk': 'RU',
  'Asia/Vladivostok': 'RU', 'Asia/Kamchatka': 'RU', 'Africa/Kigali': 'RW', 'America/St_Kitts': 'KN',
  'America/St_Lucia': 'LC', 'America/St_Vincent': 'VC', 'Pacific/Apia': 'WS', 'Europe/San_Marino': 'SM',
  'Africa/Sao_Tome': 'ST', 'Asia/Riyadh': 'SA', 'Africa/Dakar': 'SN', 'Europe/Belgrade': 'RS',
  'Indian/Mahe': 'SC', 'Africa/Freetown': 'SL', 'Asia/Singapore': 'SG', 'Europe/Bratislava': 'SK',
  'Europe/Ljubljana': 'SI', 'Pacific/Guadalcanal': 'SB', 'Africa/Mogadishu': 'SO', 'Africa/Johannesburg': 'ZA',
  'Asia/Seoul': 'KR', 'Africa/Juba': 'SS', 'Europe/Madrid': 'ES', 'Asia/Colombo': 'LK',
  'Africa/Khartoum': 'SD', 'America/Paramaribo': 'SR', 'Europe/Stockholm': 'SE', 'Europe/Zurich': 'CH',
  'Asia/Damascus': 'SY', 'Asia/Taipei': 'TW', 'Asia/Dushanbe': 'TJ', 'Africa/Dar_es_Salaam': 'TZ',
  'Asia/Bangkok': 'TH', 'Asia/Dili': 'TL', 'Africa/Lome': 'TG', 'Pacific/Tongatapu': 'TO',
  'America/Port_of_Spain': 'TT', 'Africa/Tunis': 'TN', 'Europe/Istanbul': 'TR', 'Asia/Ashgabat': 'TM',
  'Pacific/Funafuti': 'TV', 'Africa/Kampala': 'UG', 'Europe/Kyiv': 'UA', 'Europe/Kiev': 'UA',
  'Asia/Dubai': 'AE', 'Europe/London': 'GB', 'America/New_York': 'US', 'America/Chicago': 'US',
  'America/Denver': 'US', 'America/Los_Angeles': 'US', 'America/Anchorage': 'US', 'Pacific/Honolulu': 'US',
  'America/Montevideo': 'UY', 'Asia/Tashkent': 'UZ', 'Pacific/Efate': 'VU', 'America/Caracas': 'VE',
  'Asia/Ho_Chi_Minh': 'VN', 'Asia/Aden': 'YE', 'Africa/Lusaka': 'ZM', 'Africa/Harare': 'ZW',
}

const DEFAULT_DIAL_CODE = '+1'

// Time-zone-first: it mirrors the OS's location setting. Browser/OS
// language (navigator.language) is a poor proxy for country -- e.g. an
// India-based Windows install with an English (UK) language pack reports
// "en-GB", which would otherwise outrank the correct "Asia/Kolkata" zone.
// Locale region is kept only as a fallback for the rare case a time zone
// isn't resolvable at all.
const guessDialCode = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    const countryCode = TIMEZONE_COUNTRY_MAP[tz]
    if (countryCode) {
      const match = COUNTRY_CODES.find(c => c.code === countryCode)
      if (match) return match.dialCode
    }
  } catch (e) {
    // ignore timezone lookup errors
  }

  try {
    const locales = (typeof navigator !== 'undefined' && navigator.languages?.length)
      ? navigator.languages
      : [typeof navigator !== 'undefined' ? navigator.language : null].filter(Boolean)

    for (const loc of locales) {
      const region = loc?.split('-').find(p => /^[A-Z]{2}$/.test(p))
      if (region) {
        const match = COUNTRY_CODES.find(c => c.code === region)
        if (match) return match.dialCode
      }
    }
  } catch (e) {
    // ignore locale parsing errors
  }

  return DEFAULT_DIAL_CODE
}

function CountryCodeSelect({ value, onChange }) {
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')
  const ref = useRef(null)

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  useEffect(() => {
    if (!open) setSearch('')
  }, [open])

  const filtered = search.trim()
    ? COUNTRY_CODES.filter(c => (
      c.name.toLowerCase().includes(search.trim().toLowerCase()) ||
      c.dialCode.includes(search.trim())
    ))
    : COUNTRY_CODES

  return (
    <div ref={ref} className="country-select">
      <button
        type="button"
        className="country-select__toggle"
        onClick={() => setOpen(o => !o)}
      >
        {value} <span className="country-select__caret">▾</span>
      </button>
      {open && (
        <div className="country-select__dropdown">
          <input
            type="text"
            className="country-select__search"
            placeholder="Search country..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoFocus
          />
          <div className="country-select__list">
            {filtered.map((c) => (
              <button
                key={c.code}
                type="button"
                className={`country-select__option${c.dialCode === value ? ' country-select__option--active' : ''}`}
                onClick={() => { onChange(c.dialCode); setOpen(false) }}
              >
                {c.dialCode} — {c.name}
              </button>
            ))}
            {filtered.length === 0 && (
              <div className="country-select__empty">No matches</div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

// Rendered standalone at /chat/:jobId, or embedded (e.g. the create-job
// "Experience as candidate" preview) with `jobId` passed in and `embedded` set
// so it sits inline instead of taking over the viewport.
const Chat = ({ jobId: jobIdProp, embedded = false } = {}) => {
  const { jobId: routeJobId } = useParams()
  const jobId = jobIdProp || routeJobId
  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [brandingLoading, setBrandingLoading] = useState(false)
  const tenantBranding = useSelector((state) => state.qualifyQuestions?.tenantBranding)
  const isWhiteLabel = Boolean(tenantBranding?.is_white_label)
  const logoSrc = isWhiteLabel && tenantBranding?.logo
    ? tenantBranding.logo
    : '/images/gappeoai-sm-logo.svg'

  useEffect(() => {
    const token = searchParams.get('t')
    if (!token) return
    setBrandingLoading(true)
    dispatch(fetchTenantBranding(token)).finally(() => setBrandingLoading(false))
  }, [searchParams, dispatch])

  useEffect(() => {
    if (isWhiteLabel && tenantBranding?.colour) {
      document.documentElement.style.setProperty('--qualify-accent-color', tenantBranding.colour)
    }
  }, [isWhiteLabel, tenantBranding?.colour])

  const clientId = useMemo(() => {
    let id = localStorage.getItem('gappeo_webchat_client_id')
    if (!id) {
      id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
      localStorage.setItem('gappeo_webchat_client_id', id)
    }
    return id
  }, [])

  const [messages, setMessages] = useState([])
  const [inputText, setInputText] = useState('')
  const [isBotTyping, setIsBotTyping] = useState(false)
  const [pendingAttachment, setPendingAttachment] = useState(null)
  const [isProcessingResume, setIsProcessingResume] = useState(false)
  const [evaluationCountdown, setEvaluationCountdown] = useState(null)
  const [isReconnecting, setIsReconnecting] = useState(false)
  // Answer-replay experiment (disabled -- testing a resume-token based
  // reconnect instead). Re-enable if the resume-token approach doesn't work.
  // const [isReplayingAnswers, setIsReplayingAnswers] = useState(false)
  const [sessionState, setSessionState] = useState('')
  const [phoneDialCode, setPhoneDialCode] = useState(() => guessDialCode())
  const [phoneNumber, setPhoneNumber] = useState('')

  const wsRef = useRef(null)
  const chatMessagesRef = useRef(null)
  const fileInputRef = useRef(null)
  const containerRef = useRef(null)
  const chatInputRef = useRef(null)
  const chatInputAreaRef = useRef(null)
  const evaluationIntervalRef = useRef(null)
  const reconnectTimeoutRef = useRef(null)
  const reconnectAttemptsRef = useRef(0)
  const shouldReconnectRef = useRef(true)
  const heartbeatIntervalRef = useRef(null)
  const heartbeatTimeoutRef = useRef(null)
  const dialCodeTouchedRef = useRef(false)
  // Answer-replay experiment (disabled -- testing a resume-token based
  // reconnect instead). Re-enable if the resume-token approach doesn't work.
  // // Every answer the user has sent this session, in order -- replayed
  // // silently after a reconnect (see connectWs) since the backend restarts
  // // the conversation from the first question instead of resuming state.
  // const answersHistoryRef = useRef([])
  // const replayQueueRef = useRef([])
  // const isReplayingRef = useRef(false)
  // const sendMessageRef = useRef(null)
  // Not React state: nothing in JSX renders off these, and sendMessage
  // needs the value the instant a webchat_response updates it -- as state,
  // a reply sent synchronously within the same onmessage callback (e.g. a
  // silent replay send) would still see the pre-update value and send a
  // stale ws_session_token, which the backend rejects as a session mismatch.
  const refTokenRef = useRef('')
  const wsSessionTokenRef = useRef('')
  const externalUserIdRef = useRef('')

  const HEARTBEAT_INTERVAL_MS = 5000
  const HEARTBEAT_TIMEOUT_MS = 2000
  const KEYBOARD_SHRINK_THRESHOLD_PX = 120
  const PIN_IDLE_RELEASE_MS = 4000
  // These in-app WebViews never resize the viewport for the keyboard, so its
  // real height can't be measured -- this is a fixed estimate covering the
  // system keyboard + QuickType suggestion bar across current iPhone sizes.
  // Anchoring from the bottom (rather than a top offset into the viewport)
  // means the bar sits just above the keyboard regardless of the bar's own
  // height, instead of floating at a fraction of the screen.
  const KEYBOARD_HEIGHT_ESTIMATE_PX = 300
  const computePinBottomPx = () => Math.min(KEYBOARD_HEIGHT_ESTIMATE_PX, window.innerHeight * 0.5)

  const wsUrl = `${process.env.REACT_APP_WS_URL}?type=WEBCHAT&webchat_client_id=${encodeURIComponent(clientId)}`

  // Locale/time zone are device settings and can be wrong (e.g. a
  // US-provisioned laptop physically in India), so they're only used as an
  // instant placeholder above. IP geolocation reflects where the candidate
  // is actually connecting from, so it overrides that placeholder once it
  // resolves -- unless the candidate has already picked a country manually.
  useEffect(() => {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 4000)

    fetch('https://ipapi.co/json/', { signal: controller.signal })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (dialCodeTouchedRef.current) return
        const countryCode = data?.country_code || data?.country
        if (!countryCode) return
        const match = COUNTRY_CODES.find(c => c.code === countryCode)
        if (match) setPhoneDialCode(match.dialCode)
      })
      .catch(() => {
        // network blocked/rate-limited/etc -- keep the locale/timezone guess
      })
      .finally(() => clearTimeout(timeoutId))

    return () => {
      clearTimeout(timeoutId)
      controller.abort()
    }
  }, [])

  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]')
    if (!meta) return undefined
    const original = meta.getAttribute('content') || ''
    if (!/interactive-widget=/.test(original)) {
      meta.setAttribute('content', `${original}, interactive-widget=resizes-content`)
    }
    return () => {
      meta.setAttribute('content', original)
    }
  }, [])

  useEffect(() => {
    const container = chatMessagesRef.current
    if (!container) return
    const frame = requestAnimationFrame(() => {
      container.scrollTop = container.scrollHeight
    })
    return () => cancelAnimationFrame(frame)
  }, [messages, isBotTyping, isProcessingResume, evaluationCountdown, pendingAttachment])

  const lastViewportHeightRef = useRef(null)
  const lastViewportOffsetRef = useRef(0)
  const viewportRafRef = useRef(null)
  const scrollIntoViewRafRef = useRef(null)
  const keyboardPollRef = useRef(null)
  const focusTimeoutsRef = useRef([])
  const keyboardOverlayHeightRef = useRef(0)
  const isInputFocusedRef = useRef(false)
  const preFocusViewportHeightRef = useRef(null)
  const isPinnedAboveKeyboardRef = useRef(false)
  const pinIdleTimeoutRef = useRef(null)

  const setPinnedAboveKeyboard = useCallback((pinned) => {
    if (pinned === isPinnedAboveKeyboardRef.current) return
    isPinnedAboveKeyboardRef.current = pinned

    if (pinIdleTimeoutRef.current) {
      clearTimeout(pinIdleTimeoutRef.current)
      pinIdleTimeoutRef.current = null
    }

    chatInputAreaRef.current?.classList.toggle('chat-input-area--pinned-above-keyboard', pinned)
    chatMessagesRef.current?.classList.toggle('chat-messages--reserve-pinned-input', pinned)

    if (pinned) {
      const el = containerRef.current
      if (el) el.style.setProperty('--gp-pin-bottom', `${computePinBottomPx()}px`)

      pinIdleTimeoutRef.current = setTimeout(() => setPinnedAboveKeyboard(false), PIN_IDLE_RELEASE_MS)
    }

    const messagesEl = chatMessagesRef.current
    if (messagesEl) messagesEl.scrollTop = messagesEl.scrollHeight
  }, [])

  const notePinnedActivity = useCallback(() => {
    if (!isPinnedAboveKeyboardRef.current) return
    if (pinIdleTimeoutRef.current) clearTimeout(pinIdleTimeoutRef.current)
    pinIdleTimeoutRef.current = setTimeout(() => setPinnedAboveKeyboard(false), PIN_IDLE_RELEASE_MS)
  }, [setPinnedAboveKeyboard])

  const syncViewportAndScroll = useCallback(() => {
    if (viewportRafRef.current) return
    viewportRafRef.current = requestAnimationFrame(() => {
      viewportRafRef.current = null

      const overlayHeight = keyboardOverlayHeightRef.current
      const vh = overlayHeight > 0
        ? window.innerHeight - overlayHeight
        : (window.visualViewport?.height || window.innerHeight)

      if (vh !== lastViewportHeightRef.current) {
        lastViewportHeightRef.current = vh
        const el = containerRef.current
        if (el) el.style.setProperty('--gp-vh', `${vh}px`)

        const messagesEl = chatMessagesRef.current
        if (messagesEl) messagesEl.scrollTop = messagesEl.scrollHeight
      }

      // iOS WebKit quirk: position:fixed elements track the layout
      // viewport, not the visual one, so they don't move when Safari pans
      // the page to reveal a focused input above the keyboard. Even with
      // --gp-vh correctly shrunk to visualViewport.height, the box stays
      // glued to the old top edge, leaving a gap exactly offsetTop pixels
      // tall between it and the keyboard. Translating by that offset keeps
      // it following the pan. Android doesn't have this quirk (offsetTop is
      // always 0 there), so this is scoped to iOS only -- both to skip the
      // pointless writes and so .chart-container's transform (and the
      // compositing layer + fixed-position containing block it creates)
      // only exists on the platform that actually needs it.
      if (IS_IOS) {
        const offsetTop = window.visualViewport?.offsetTop || 0
        if (offsetTop !== lastViewportOffsetRef.current) {
          lastViewportOffsetRef.current = offsetTop
          const el = containerRef.current
          if (el) el.style.setProperty('--gp-vh-offset', `${offsetTop}px`)
        }
      }

      if (IS_IN_APP_BROWSER && isInputFocusedRef.current && preFocusViewportHeightRef.current != null) {
        const shrink = preFocusViewportHeightRef.current - vh
        setPinnedAboveKeyboard(shrink < KEYBOARD_SHRINK_THRESHOLD_PX)
      }
    })
  }, [setPinnedAboveKeyboard])
  const queueScrollIntoView = useCallback((target) => {
    if (scrollIntoViewRafRef.current) cancelAnimationFrame(scrollIntoViewRafRef.current)
    scrollIntoViewRafRef.current = requestAnimationFrame(() => {
      scrollIntoViewRafRef.current = null
      target.scrollIntoView({ block: 'nearest' })
    })
  }, [])

  const stopKeyboardPolling = useCallback(() => {
    if (keyboardPollRef.current) {
      clearInterval(keyboardPollRef.current)
      keyboardPollRef.current = null
    }
    focusTimeoutsRef.current.forEach(clearTimeout)
    focusTimeoutsRef.current = []
    isInputFocusedRef.current = false
    preFocusViewportHeightRef.current = null
    setPinnedAboveKeyboard(false)

    // Blurring the input is an unambiguous "the keyboard is closing" signal
    // on iOS (unlike the WebViews the rest of this file works around, where
    // even that can be unreliable). visualViewport's own resize/scroll
    // events should already bring offsetTop back to 0 when that happens,
    // but force it here too as a guaranteed floor -- if it were ever missed,
    // the entire chat would stay shifted downward after the keyboard closes.
    if (IS_IOS) {
      lastViewportOffsetRef.current = 0
      containerRef.current?.style.setProperty('--gp-vh-offset', '0px')
    }
  }, [setPinnedAboveKeyboard])

  const startKeyboardPolling = useCallback((target) => {
    stopKeyboardPolling()

    isInputFocusedRef.current = true
    preFocusViewportHeightRef.current = window.visualViewport?.height || window.innerHeight

    keyboardPollRef.current = setInterval(syncViewportAndScroll, 300)
    focusTimeoutsRef.current = [0, 100, 250, 400, 600, 900].map(delay => setTimeout(() => {
      syncViewportAndScroll()
      queueScrollIntoView(target)
    }, delay))
  }, [syncViewportAndScroll, queueScrollIntoView, stopKeyboardPolling])

  useEffect(() => {
    syncViewportAndScroll()
    window.visualViewport?.addEventListener('resize', syncViewportAndScroll)
    // offsetTop (how far Safari has panned the visual viewport) changes fire
    // 'scroll' on visualViewport, not 'resize' -- both are needed to catch
    // the iOS pan-without-resize gap described above.
    window.visualViewport?.addEventListener('scroll', syncViewportAndScroll)
    window.addEventListener('resize', syncViewportAndScroll)

    return () => {
      window.visualViewport?.removeEventListener('resize', syncViewportAndScroll)
      window.visualViewport?.removeEventListener('scroll', syncViewportAndScroll)
      window.removeEventListener('resize', syncViewportAndScroll)
      stopKeyboardPolling()
      if (viewportRafRef.current) cancelAnimationFrame(viewportRafRef.current)
      if (scrollIntoViewRafRef.current) cancelAnimationFrame(scrollIntoViewRafRef.current)
    }
  }, [syncViewportAndScroll, stopKeyboardPolling])

  useEffect(() => {
    if (!('virtualKeyboard' in navigator)) return undefined

    navigator.virtualKeyboard.overlaysContent = true
    const handleGeometryChange = () => {
      keyboardOverlayHeightRef.current = navigator.virtualKeyboard.boundingRect?.height || 0
      syncViewportAndScroll()
    }
    navigator.virtualKeyboard.addEventListener('geometrychange', handleGeometryChange)

    return () => {
      navigator.virtualKeyboard.removeEventListener('geometrychange', handleGeometryChange)
      navigator.virtualKeyboard.overlaysContent = false
      keyboardOverlayHeightRef.current = 0
    }
  }, [syncViewportAndScroll])

  useEffect(() => {
    const handleOutsideTouch = (e) => {
      if (!isPinnedAboveKeyboardRef.current) return
      if (chatInputAreaRef.current?.contains(e.target)) return
      setPinnedAboveKeyboard(false)
    }
    document.addEventListener('touchstart', handleOutsideTouch, { passive: true })
    return () => document.removeEventListener('touchstart', handleOutsideTouch)
  }, [setPinnedAboveKeyboard])

  const clearEvaluationCountdown = useCallback(() => {
    if (evaluationIntervalRef.current) {
      clearInterval(evaluationIntervalRef.current)
      evaluationIntervalRef.current = null
    }
    setEvaluationCountdown(null)
  }, [])

  const startEvaluationCountdown = useCallback(() => {
    clearEvaluationCountdown()
    setEvaluationCountdown(30)
    evaluationIntervalRef.current = setInterval(() => {
      setEvaluationCountdown(prev => {
        if (prev === null || prev <= 1) {
          clearInterval(evaluationIntervalRef.current)
          evaluationIntervalRef.current = null
          return null
        }
        return prev - 1
      })
    }, 1000)
  }, [clearEvaluationCountdown])

  const getBotText = (response) => response?.template?.text?.trim() || response?.text || ''

  const appendBotResponse = useCallback((list, response) => {
    const newText = getBotText(response)
    const last = list[list.length - 1]
    const lastText = last?.role === 'bot' ? getBotText(last.response) : null
    if (lastText !== null && lastText === newText) return list
    return [...list, { role: 'bot', response, ts: Date.now() }]
  }, [])

  const stopHeartbeat = useCallback(() => {
    if (heartbeatIntervalRef.current) {
      clearInterval(heartbeatIntervalRef.current)
      heartbeatIntervalRef.current = null
    }
    if (heartbeatTimeoutRef.current) {
      clearTimeout(heartbeatTimeoutRef.current)
      heartbeatTimeoutRef.current = null
    }
  }, [])

  const startHeartbeat = useCallback((ws) => {
    stopHeartbeat()
    heartbeatIntervalRef.current = setInterval(() => {
      if (ws.readyState !== WebSocket.OPEN) return
      if (heartbeatTimeoutRef.current) clearTimeout(heartbeatTimeoutRef.current)
      ws.send(JSON.stringify({ action: 'ping' }))
      heartbeatTimeoutRef.current = setTimeout(() => {
        ws.close()
      }, HEARTBEAT_TIMEOUT_MS)
    }, HEARTBEAT_INTERVAL_MS)
  }, [stopHeartbeat])

  const connectWs = useCallback(() => {
    const ws = new WebSocket(wsUrl)
    wsRef.current = ws

    ws.onopen = () => {
      reconnectAttemptsRef.current = 0
      setIsReconnecting(false)
      startHeartbeat(ws)
    }

    ws.onmessage = (evt) => {
      try {
        const data = JSON.parse(evt.data)

        if (data.type === 'pong') {
          if (heartbeatTimeoutRef.current) {
            clearTimeout(heartbeatTimeoutRef.current)
            heartbeatTimeoutRef.current = null
          }
          return
        }

        if (data.type === 'your_id') {
          const extId = `webchat-${clientId}`
          externalUserIdRef.current = extId

          // Resume-token reconnect experiment: if we already have a
          // session/ref token from before (i.e. this is a reconnect, not
          // the first connection), ask the backend to resume using those
          // instead of restarting the flow with webchat_init.
          if (wsSessionTokenRef.current) {
            const clientMessageId = (window.crypto && window.crypto.randomUUID)
              ? window.crypto.randomUUID()
              : `cm-${Date.now()}-${Math.random().toString(16).slice(2)}`
            ws.send(JSON.stringify({
              action: 'webchat_message',
              client_message_id: clientMessageId,
              ws_session_token: wsSessionTokenRef.current,
              ref_token: refTokenRef.current,
              external_user_id: extId,
              text: '',
            }))
          } else {
            const recruiterCode = new URLSearchParams(window.location.search).get('rc')
            ws.send(JSON.stringify({
              action: 'webchat_init',
              job_id: jobId,
              external_user_id: extId,
              metadata: { source: 'apply_page' },
              ...(recruiterCode && { recruiter_code: recruiterCode }),
            }))
          }
          setIsBotTyping(true)

          // Answer-replay experiment (disabled -- testing the resume-token
          // approach above instead). Re-enable if that doesn't work.
          // // Reconnecting mid-flow: the backend restarts the conversation
          // // from the first question, so silently replay every answer the
          // // user already gave instead of asking again.
          // if (answersHistoryRef.current.length > 0) {
          //   isReplayingRef.current = true
          //   replayQueueRef.current = [...answersHistoryRef.current]
          //   setIsReplayingAnswers(true)
          // }
        }

        if (data.type === 'webchat_response') {
          clearEvaluationCountdown()

          if (data.external_user_id) externalUserIdRef.current = data.external_user_id
          if (data.ref_token) refTokenRef.current = data.ref_token
          if (data.ws_session_token) wsSessionTokenRef.current = data.ws_session_token
          setIsProcessingResume(data.session?.state === 'processing_resume')
          setSessionState(data.session?.state || '')

          // Answer-replay experiment (disabled -- testing the resume-token
          // approach in the your_id handler above instead). Re-enable if
          // that doesn't work.
          // // The backend restarts its own "current question" pointer from
          // // scratch on reconnect (even though it still reports the real
          // // chat_history), so chat_history isn't a reliable signal that it
          // // resumed properly -- always drain our local replay queue first.
          // // Our own `messages` state already reflects everything shown
          // // before the disconnect, so it's left untouched here; only once
          // // the queue is empty do we fall through to display a response.
          // if (isReplayingRef.current) {
          //   const nextAnswer = replayQueueRef.current.shift()
          //   if (nextAnswer) {
          //     sendMessageRef.current?.(nextAnswer.text, nextAnswer.displayText, {
          //       silent: true,
          //       attachment: nextAnswer.attachment,
          //     })
          //     return
          //   }
          //   isReplayingRef.current = false
          //   setIsReplayingAnswers(false)
          // }

          const historyMessages = (data.chat_history?.length > 0)
            ? data.chat_history.map((item, i, arr) => {
                if (item.direction === 'outbound') {
                  const wasAnswered = arr[i + 1]?.direction === 'inbound'
                  return {
                    role: 'bot',
                    response: {
                      text: item.text,
                      template: item.buttons?.length ? { buttons: item.buttons } : null,
                      quick_replies: [],
                    },
                    buttonsClicked: wasAnswered,
                    ts: i,
                  }
                }
                return {
                  role: 'user',
                  text: item.text,
                  fileAttachment: item.attachments?.[0]
                    ? { name: item.attachments[0].file_name, mimeType: item.attachments[0].mime_type, size: null }
                    : null,
                  ts: i,
                }
              })
            : []

          if (historyMessages.length > 0) {
            setMessages(() => appendBotResponse(historyMessages, data.response))
          } else {
            setMessages(prev => appendBotResponse(prev, data.response))
          }
          setIsBotTyping(false)

          if (data.session?.state === 'pre_screen_evaluating') {
            startEvaluationCountdown()
          }
        }

        if (data.type === 'webchat_error') {
          setIsBotTyping(false)
          setIsProcessingResume(false)
          clearEvaluationCountdown()
        }
      } catch (e) {
        // ignore non-json frames
      }
    }

    ws.onerror = () => setIsBotTyping(false)

    ws.onclose = () => {
      stopHeartbeat()

      if (!shouldReconnectRef.current) return

      setIsBotTyping(false)
      setIsReconnecting(true)
    }
  }, [jobId, wsUrl, clientId, startEvaluationCountdown, clearEvaluationCountdown, appendBotResponse, startHeartbeat, stopHeartbeat])

  const handleManualReconnect = useCallback(() => {
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current)
      reconnectTimeoutRef.current = null
    }
    reconnectAttemptsRef.current = 0
    wsRef.current?.close()
    connectWs()
  }, [connectWs])

  useEffect(() => {
    if (!jobId) return

    // Answer-replay experiment (disabled). Re-enable alongside the refs above.
    // answersHistoryRef.current = []
    shouldReconnectRef.current = true
    reconnectAttemptsRef.current = 0
    connectWs()

    return () => {
      shouldReconnectRef.current = false
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current)
        reconnectTimeoutRef.current = null
      }
      wsRef.current?.close()
      clearEvaluationCountdown()
      stopHeartbeat()
    }
  }, [jobId, connectWs, clearEvaluationCountdown, stopHeartbeat])

  // Answer-replay experiment (disabled -- testing the resume-token approach
  // instead). Re-enable this version (and the refs/effect below it) if that
  // doesn't work.
  // // `silent` is used for replaying already-answered steps after a
  // // reconnect: it sends the answer over the wire without adding it to the
  // // visible messages (it's already there from the first time) or touching
  // // the live inputText/pendingAttachment the user may be mid-typing.
  // const sendMessage = useCallback((textOverride, displayTextOverride, options = {}) => {
  //   const { attachment: attachmentOverride, silent = false } = options
  //   const text = (textOverride !== undefined ? textOverride : inputText).trim()
  //   const displayText = (
  //     displayTextOverride !== undefined ? displayTextOverride
  //       : textOverride !== undefined ? textOverride
  //         : inputText
  //   ).trim()
  //   const attachment = attachmentOverride !== undefined ? attachmentOverride : pendingAttachment
  //   const hasAttachment = !!attachment
  //
  //   if (!text && !hasAttachment) return
  //   if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) return
  //
  //   const extId = externalUserIdRef.current || `webchat-${clientId}`
  //
  //   const clientMessageId = (window.crypto && window.crypto.randomUUID)
  //     ? window.crypto.randomUUID()
  //     : `cm-${Date.now()}-${Math.random().toString(16).slice(2)}`
  //
  //   const payload = {
  //     action: 'webchat_message',
  //     client_message_id: clientMessageId,
  //     external_user_id: extId,
  //     text: text || 'Uploaded a file',
  //     metadata: { source: 'apply_page' },
  //   }
  //
  //   if (wsSessionTokenRef.current) payload.ws_session_token = wsSessionTokenRef.current
  //
  //   if (attachment) {
  //     payload.attachments = [{
  //       mime_type: attachment.mimeType,
  //       content_base64: attachment.base64,
  //       file_name: attachment.name,
  //       name: attachment.name,
  //     }]
  //   }
  //
  //   if (refTokenRef.current) {
  //     payload.ref_token = refTokenRef.current
  //   } else if (jobId) {
  //     payload.job_id = jobId
  //     payload.metadata = { ...payload.metadata, job_id: jobId }
  //   }
  //
  //   wsRef.current.send(JSON.stringify(payload))
  //
  //   if (!silent) {
  //     answersHistoryRef.current.push({ text, displayText, attachment: attachment || null })
  //     setMessages(prev => [...prev, {
  //       role: 'user',
  //       text: displayText || '',
  //       fileAttachment: attachment ? { name: attachment.name, size: attachment.size, mimeType: attachment.mimeType } : null,
  //       ts: Date.now(),
  //     }])
  //     setInputText('')
  //     setPendingAttachment(null)
  //     if (fileInputRef.current) fileInputRef.current.value = ''
  //   }
  //   setIsBotTyping(true)
  // }, [inputText, pendingAttachment, clientId, jobId])
  //
  // useEffect(() => {
  //   sendMessageRef.current = sendMessage
  // }, [sendMessage])

  const sendMessage = useCallback((textOverride, displayTextOverride) => {
    const text = (textOverride !== undefined ? textOverride : inputText).trim()
    const displayText = (
      displayTextOverride !== undefined ? displayTextOverride
        : textOverride !== undefined ? textOverride
          : inputText
    ).trim()
    const hasAttachment = !!pendingAttachment

    if (!text && !hasAttachment) return
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) return

    const extId = externalUserIdRef.current || `webchat-${clientId}`

    const clientMessageId = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `cm-${Date.now()}-${Math.random().toString(16).slice(2)}`

    const payload = {
      action: 'webchat_message',
      client_message_id: clientMessageId,
      external_user_id: extId,
      text: text || 'Uploaded a file',
      metadata: { source: 'apply_page' },
    }

    if (wsSessionTokenRef.current) payload.ws_session_token = wsSessionTokenRef.current

    if (pendingAttachment) {
      payload.attachments = [{
        mime_type: pendingAttachment.mimeType,
        content_base64: pendingAttachment.base64,
        file_name: pendingAttachment.name,
        name: pendingAttachment.name,
      }]
    }

    if (refTokenRef.current) {
      payload.ref_token = refTokenRef.current
    } else if (jobId) {
      payload.job_id = jobId
      payload.metadata = { ...payload.metadata, job_id: jobId }
    }

    wsRef.current.send(JSON.stringify(payload))

    setMessages(prev => [...prev, {
      role: 'user',
      text: displayText || '',
      fileAttachment: pendingAttachment ? { name: pendingAttachment.name, size: pendingAttachment.size, mimeType: pendingAttachment.mimeType } : null,
      ts: Date.now(),
    }])
    setIsBotTyping(true)
    setInputText('')
    setPendingAttachment(null)
    if (fileInputRef.current) fileInputRef.current.value = ''
  }, [inputText, pendingAttachment, clientId, jobId])

  const sendPhoneNumber = useCallback(() => {
    const digits = phoneNumber.trim()
    if (!digits) return
    sendMessage(`${phoneDialCode}${digits}`)
    setPhoneNumber('')
  }, [phoneNumber, phoneDialCode, sendMessage])

  const handleButtonClick = useCallback((msgIdx, btnPayload, label) => {
    setMessages(prev => prev.map((m, i) => i === msgIdx ? { ...m, buttonsClicked: true } : m))
    sendMessage(btnPayload, label)
  }, [sendMessage])

  // Link buttons carry the candidate's next stage (assessment, voice/video
  // call, scheduling), so they open in this tab instead of a new one. The
  // embedded create-job preview keeps the new tab so the recruiter isn't
  // pulled out of the job flow.
  const handleLinkClick = useCallback((e, url) => {
    if (IS_IN_APP_BROWSER) {
      e.preventDefault()
      openExternally(url)
      return
    }
    if (embedded) return

    e.preventDefault()
    try {
      const target = new URL(url, window.location.origin)
      if (target.origin === window.location.origin) {
        navigate(target.pathname + target.search + target.hash)
        return
      }
    } catch (err) {
      // not a parseable URL -- let the browser handle it below
    }
    window.location.href = url
  }, [embedded, navigate])

  const processFile = async (file) => {
    if (!file) return
    const allowedMime = [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ]
    const isAllowed = allowedMime.includes(file.type) || /\.(pdf|docx)$/i.test(file.name)
    if (!isAllowed) return

    try {
      const dataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result || ''))
        reader.onerror = () => reject(new Error('read failed'))
        reader.readAsDataURL(file)
      })
      const base64 = dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl
      setPendingAttachment({
        name: file.name,
        size: file.size,
        mimeType: file.type || 'application/octet-stream',
        base64,
      })
    } catch (e) {
      // ignore file read errors
    }
  }

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0]
    if (file) await processFile(file)
    e.target.value = ''
  }

  const removeAttachment = () => {
    setPendingAttachment(null)
    if (fileInputRef.current) fileInputRef.current.value = ''
  }

  if (brandingLoading) {
    return (
      <div className={`chart-container${IS_IOS && !embedded ? ' chart-container--ios' : ''}${embedded ? ' chart-container--embedded' : ''}`}>
        <div className="loading-overlay">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`chart-container${IS_IOS && !embedded ? ' chart-container--ios' : ''}${embedded ? ' chart-container--embedded' : ''}`} ref={containerRef}>
      {/* Left: Chat Area */}
      <div className="chat-area">
        <div className="chat-header">
          <div className="chat-header__brand">
            <div className="brand-icon">
              {/* <LightningIcon /> */}
              <img src={logoSrc} alt='' width={160} height={80} />
            </div>
            <div className="brand-info">
              <h2 className="brand-name">{isWhiteLabel && tenantBranding.name ? tenantBranding.name : 'Gappeo'}</h2>
              <div className="brand-status">
                {/* Answer-replay experiment (disabled). Re-enable with isReplayingAnswers:
                <span className={`status-dot${(isReconnecting || isReplayingAnswers) ? ' status-dot--reconnecting' : ''}`} />
                <span className="status-text">{isReconnecting ? 'Reconnecting...' : isReplayingAnswers ? 'Restoring your progress...' : 'AI Hiring Assistant'}</span>
                */}
                <span className={`status-dot${isReconnecting ? ' status-dot--reconnecting' : ''}`} />
                <span className="status-text">{isReconnecting ? 'Reconnecting...' : 'AI Hiring Assistant'}</span>
              </div>
            </div>
          </div>
          {/* TEMP TEST BUTTON -- remove after disconnect/reconnect QA */}
          {/* <button
            type="button"
            className="test-disconnect-btn"
            onClick={() => wsRef.current?.close()}
          >
            Disconnect (test)
          </button> */}
        </div>

        <div className="chat-messages" ref={chatMessagesRef}>
          {isReconnecting && (
            <div className="disconnect-banner">
              Session disconnected. Please reconnect.
            </div>
          )}
          {messages.map((msg, idx) => {
            if (msg.role === 'bot') {
              const response = msg.response || {}
              const buttons = [
                ...(response?.template?.buttons || []),
                ...(response?.quick_replies || []),
              ]
              return (
                <div key={idx} className="message">
                  <div className="message__avatar">
                    {/* <LightningIcon /> */}
                    <img src={logoSrc} alt='' width={160} height={80} />
                  </div>
                  <div className="message__bubble">
                    {response?.template?.text?.trim() || response?.text || ''}
                    {buttons.length > 0 && (
                      <div className="message-buttons">
                        {buttons.map((b, bIdx) => {
                          const label = b.title || b.label || b.payload || `Option ${bIdx + 1}`
                          if (b.type === 'web_url' && b.url) {
                            return (
                              <a
                                key={bIdx}
                                className="message-btn"
                                href={b.url}
                                target={embedded ? '_blank' : undefined}
                                rel="noopener noreferrer"
                                onClick={(e) => handleLinkClick(e, b.url)}
                              >
                                {label}
                              </a>
                            )
                          }
                          const btnPayload = b.payload || label
                          return (
                            <button
                              key={bIdx}
                              className="message-btn"
                              disabled={!!msg.buttonsClicked}
                              onClick={() => handleButtonClick(idx, btnPayload, label)}
                            >
                              {label}
                            </button>
                          )
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )
            }

            return (
              <div key={idx} className="message message--user">
                <div className="message__bubble message__bubble--user">
                  {msg.text || null}
                  {msg.fileAttachment && (
                    <div className="file-attachment">
                      <div className="file-attachment__icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                        </svg>
                      </div>
                      <div className="file-attachment__info">
                        <span className="file-attachment__name">{msg.fileAttachment.name}</span>
                        <span className="file-attachment__type">{msg.fileAttachment.mimeType === 'application/pdf' ? 'PDF' : 'DOCX'}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          })}

          {isBotTyping && (
            <div className="message">
              <div className="message__avatar">
                {/* <LightningIcon /> */}
                <img src='/images/gappeoai-sm-logo.svg' alt='' />
              </div>
              <div className="message__bubble message__bubble--typing">
                <span className="typing-dot" />
                <span className="typing-dot" />
                <span className="typing-dot" />
              </div>
            </div>
          )}
        </div>

        {isProcessingResume && (
          <div className="resume-processing">
            <span className="resume-processing__text">Processing your resume...</span>
            <div className="resume-processing__track">
              <span className="resume-processing__bar" />
            </div>
          </div>
        )}

        {evaluationCountdown !== null && (
          <div className="resume-processing">
            <span className="resume-processing__text">Evaluating your responses, please wait... {evaluationCountdown}s</span>
            <div className="resume-processing__track">
              <span className="resume-processing__bar" />
            </div>
          </div>
        )}

        {pendingAttachment && (
          <div className="pending-attachment">
            <span className="pending-attachment__name">{pendingAttachment.name}</span>
            <button className="pending-attachment__remove" type="button" onClick={removeAttachment}>
              ×
            </button>
          </div>
        )}

        <div className="chat-input-area" ref={chatInputAreaRef}>
          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            className="visually-hidden-file-input"
            onChange={handleFileChange}
            disabled={isReconnecting}
            /* Answer-replay experiment (disabled): disabled={isReconnecting || isReplayingAnswers} */
          />
          {isReconnecting ? (
            <button
              className="reconnect-btn"
              type="button"
              onClick={handleManualReconnect}
            >
              <ReconnectIcon />
              Reconnect
            </button>
          /* Answer-replay experiment (disabled). Re-enable with isReplayingAnswers:
          ) : isReplayingAnswers ? (
            <div className="restoring-progress">
              Restoring your previous answers...
            </div>
          */
          ) : sessionState === 'awaiting_phone' ? (
            <>
              <div className="phone-input-group">
                <CountryCodeSelect
                  value={phoneDialCode}
                  onChange={(code) => { dialCodeTouchedRef.current = true; setPhoneDialCode(code) }}
                />
                <input
                  ref={chatInputRef}
                  type="tel"
                  inputMode="numeric"
                  className="chat-input phone-input-group__number"
                  placeholder="Phone number"
                  value={phoneNumber}
                  onChange={e => { setPhoneNumber(e.target.value.replace(/[^\d\s\-()]/g, '')); notePinnedActivity() }}
                  onKeyDown={e => { if (e.key === 'Enter') sendPhoneNumber() }}
                  onFocus={e => startKeyboardPolling(e.target)}
                  onBlur={stopKeyboardPolling}
                  onClick={e => {
                    if (isPinnedAboveKeyboardRef.current) startKeyboardPolling(e.target)
                  }}
                />
              </div>
              <button
                className="send-btn"
                type="button"
                onMouseDown={e => e.preventDefault()}
                onClick={sendPhoneNumber}
              >
                <SendIcon />
              </button>
            </>
          ) : (
            <>
              <button
                className="attach-btn"
                type="button"
                onMouseDown={e => e.preventDefault()}
                onClick={() => fileInputRef.current?.click()}
              >
                <AttachIcon />
              </button>
              <input
                ref={chatInputRef}
                type="text"
                className="chat-input"
                placeholder="Type your answer..."
                value={inputText}
                onChange={e => { setInputText(e.target.value); notePinnedActivity() }}
                onKeyDown={e => { if (e.key === 'Enter') sendMessage() }}
                onFocus={e => startKeyboardPolling(e.target)}
                onBlur={stopKeyboardPolling}
                onClick={e => {
                  // If a gesture (not a tap elsewhere) dismissed the keyboard
                  // without blurring the input, no 'focus' event fires when the
                  // user taps it again to keep typing -- only this click does.
                  // Re-arm the same detection cycle as a fresh focus would.
                  if (isPinnedAboveKeyboardRef.current) startKeyboardPolling(e.target)
                }}
              />
              <button
                className="send-btn"
                type="button"
                // Same fix as attach-btn above -- keeps the input focused so the
                // tap isn't cancelled by a mid-tap layout shift on iOS.
                onMouseDown={e => e.preventDefault()}
                onClick={() => sendMessage()}
              >
                <SendIcon />
              </button>
            </>
          )}
        </div>
      </div>

    </div>
  )
}

export default Chat